import { ScrollerConstants } from "../_constants";

const initialState = {position: 0};

export function scroller(state = initialState, action) {
  switch(action.type) {
    case ScrollerConstants.SET_SCROLL_OFFSET: {
      return {position: action.payload}
    }
    default: {
      return state;
    }
  }
}